import { Box, Button } from "@mui/material";
import { React, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  approveQuota,
  getQuotaForApproval,
  setState,
} from "./quotaModificationSlice";


export default function ButtonGroup() {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const state = useSelector((store) => store.quotaModification);
  const {
    selectedRowsselected,
    quotaList,
    selectedCountryID,
    selectedPeriod,
    selectedQuotaStatus,
    searchText,
  } = state;

  function search() {
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRowsselected", []));
    dispatch(setState("scenarioModificationList", null));
    dispatch(setState("expandedRowIndex", null));
    const logedUser = JSON.parse(localStorage.getItem("data"));
    const countryId = selectedCountryID;
    const period = selectedPeriod;
    const quotaStatus = selectedQuotaStatus;

    const obj = {
      countryId,
      period,
      quotaStatus,
      logedUser,
      searchText: searchText,
    };
    dispatch(getQuotaForApproval(obj));
  }

  function approveSelected() {
    const user = JSON.parse(localStorage.getItem("data"));
    let qtaLst = [];
    for (let i = 0; i < selectedRowsselected.length; ++i) {
      const quota = quotaList.find(
        (item) => item.quotaId === selectedRowsselected[i].quotaId
      );
      console.log(quota);
      const obj = {
        ...quota,
        user,
      };
      qtaLst.push(obj);
    }
    console.log("Approve_Quota_ApproveSelected", qtaLst);
    dispatch(approveQuota(qtaLst)).then(() => {
      search();
    });
  }

  function openRejectionModal() {
    dispatch(setState("rejectSelModalOpen", true));
    dispatch(setState("isButtonClicked", true));
  }

  function openApproveWithCommentModal() {
    dispatch(setState("appWithCommentModal", true));
    dispatch(setState("isButtonClicked", true));
  }

  return (
    quotaList && (
      <Box
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
        }}
      >
        <Button
          className="disabled"
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            ml: 1,
            "&:hover": {
              bgcolor: "darkred.main",
              color: "white.main",
            },
          }}
          disabled={selectedRowsselected.length === 0 || !isRestrictedAccess}
          onClick={approveSelected}
        >
          Approve Selected
        </Button>

        <Button
          className="disabled"
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            ml: 1,
            "&:hover": {
              bgcolor: "darkred.main",
              color: "white.main",
            },
          }}
          disabled={selectedRowsselected.length === 0 || !isRestrictedAccess}
          onClick={openApproveWithCommentModal}
        >
          Approve With Comments Selected
        </Button>

        <Button
          className="disabled"
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            ml: 1,
            "&:hover": {
              bgcolor: "darkred.main",
              color: "white.main",
            },
          }}
          disabled={selectedRowsselected.length === 0 || !isRestrictedAccess}
          onClick={openRejectionModal}
        >
          Reject Selected
        </Button>
      </Box>
    )
  );
}
